export const state = () => ({
  page: 1,
  column: 'name',
  direction: 'asc',
  length: 25,
  search: '',
  status: ''
})

export const getters = {
  filters(state) {
    return state
  },

  page(state) {
    return state.page
  },

  length(state) {
    return state.length
  },

  search(state) {
    return state.search
  },

  column(state) {
    return state.column
  },

  direction(state) {
    return state.direction
  },

  status(state) {
    return state.status
  },

  paginationFiltersAsParams(state) {
    return {
      params: {
        'length': state.length,
        'search': state.search,
        'column': state.column,
        'direction': state.direction,
        'page': state.page,
        'status': state.status
      }
    }
  }
}

export const mutations = {
  SET_FILTER_SEARCH(state, search) {
    state.search = search
  },

  SET_FILTER_PAGE(state, page) {
    state.page = page
  },

  SET_FILTER_DIRECTION(state, direction) {
    state.direction = direction
  },

  SET_FILTER_LENGTH(state, length) {
    state.length = length
  },

  SET_FILTER_COLUMN(state, column) {
    state.column = column
  },

  SET_FILTER_STATUS(state, status) {
    state.status = status
  },

  RESET_FILTER_SEARCH(state) {
    state.search = ''
  },

  RESET_FILTERS(state) {
      state.page = 1;
      state.column = 'name';
      state.direction = 'asc';
      state.length = 25;
      state.search = ''
      state.status = ''
  }
}
